<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="" title="Staffs" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-12">
										<router-link :to="{ name: 'add_staff' }" class="btn btn-primary float-end">Add Staff</router-link>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-8 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchStaffs()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									
									<div class="col-md-2 mt-2">
										<select class="form-select" v-model="status" @change="fetchStaffs()">
											<option value="">All</option>
                                            <option value="1">Active</option>
                                            <option value="2">Blocked</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1" placeholder="Search" v-model="keyword" @keyup="fetchStaffs()"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>ID</th>  
                                            <th>Name</th>
											<th>Username</th>
											<th>Contact</th>
											<th>Status</th> 
											<th>Options</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(staffs.length)">
                                        <tr align="center" v-for="(staff, index) in staffs" :key="index">
                                            <td>{{ (from - 1) + index + 1 }}</td>
                                            <td>{{ staff.name }}</td>
											<td>{{ staff.user_name }}</td>
											<td>{{ staff.mobile}} <br>
												{{ staff.email }}
											</td>
											<td>
												<span v-if="staff.status == 1" class="badge rounded-pill bg-success">Active</span>
												<span v-else class="badge rounded-pill bg-warning">Blocked</span>											
											</td>
											<td>
												<router-link :to="{ name: 'staff_details', query: { id: staff.id } }" class="btn btn-primary me-1 mb-2 btn-sm">Profile</router-link>
												<router-link :to="{ name: 'update_staff', query: { id: staff.id } }" class="btn btn-primary me-1 mb-2 btn-sm">Edit</router-link>
                                                <button v-if="staff.status == 1" class="btn btn-warning btn-sm me-1 mb-2" @click="updateStaffStatus(staff.id, 2)">Block</button>
					                            <button v-else class="btn btn-success btn-sm me-1 mb-2" @click="updateStaffStatus(staff.id, 1)">Activate</button>
                                            </td>
                                        </tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="6" class="text-center">No staffs found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<div class="row">
									<div class="col-md-6">
										<p class="text-muted">Showing {{ from }} to {{ to }} of {{ total }} entries</p>
									</div>
									<div class="col-md-6">
										<ul class="pagination justify-content-end">
											<li class="page-item" v-for="(page, index) in pagination" :key="index" :class="[{ disabled: !page.url }, { active: page.active }]">
												<a class="page-link" href="#" @click.prevent="fetchStaffs(page.url)" tabindex="-1">
													<span v-if="index === 0">Prev</span>
													<span v-else-if="index === pagination.length - 1">Next</span>
													<span v-else v-html="page.label"></span>
												</a>
											</li>
										</ul>
									</div>
								</div>
							</nav>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script setup>
import { get, post } from '@/utils/api';
import { useRouter } from 'vue-router';
import { ref, onMounted } from 'vue';
import { routes } from '@/constants/routes';
import Swal from '@/utils/swal';

const router = useRouter();

const keyword = ref("");
const listing_length = ref(10);
const errors = ref({});
const status = ref("");
const staffs = ref([]);
const from = ref(null);
const to = ref(null);
const total = ref(null);
const pagination = ref({});

const fetchStaffs = (url = null) => {
	
	const params = {
		limit: listing_length.value,
		status: status.value,
		keyword: keyword.value
	}

	const requestUrl = url ?? routes.Staffs;

	get(requestUrl, { params }, false)
		.then((response) => {
			if(response.status === 200){
				console.log(response.data.data);
				staffs.value = response.data.data.data;
				pagination.value = response.data.data.links;
				from.value = response.data.data.from;
				to.value = response.data.data.to;
				total.value = response.data.data.total;
			} else {
				Swal.fire('', response.data.message || 'Failed to fetch staffs', 'error');
			}
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				Swal.fire('', error.response.data.message.limit?.[0] || error.response.data.message.status?.[0] || error.response.data.message.keyword?.[0] || 'Validation error', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
};

const updateStaffStatus = (staff_id, status) => {
	
	const params = {
		staff_id: staff_id,
		status: status
	}

	get(routes.UpdateStaffStatus, { params }, false)
		.then((response) => {
			if(response.status === 200){
				Swal.fire('', response.data.message || 'Staff status updated successfully', 'success');
				fetchStaffs();
			} else {
				Swal.fire('', response.data.message || 'Error in updating staff status', 'error');
			}
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				Swal.fire('', error.response.data.message.staff_id[0] || error.response.data.message.status[0] || 'Validation error', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		})
}

onMounted(() => {
	fetchStaffs();
});


</script>